import DOMHelper from "../../../../../lib/dom-helper";

export default class MultiplePage {
	constructor($root, config, courseId) {
		/* HTML elements */
		this.$root = $root;
		this.$info = this.$root.querySelector('.quiz-choice_info');
		this.$beginBlockList = this.$root.querySelectorAll('.quiz-choice_group');

		this.config = config;
		this.courseId = courseId;
		this.isInitialized = false;
	}

	init(initTestCallback) {
		if (!this.isInitialized) {
			MultiplePage.prototype.initTest = initTestCallback;
			this.setInfoText();
			this.addListeners();
			this.isInitialized = true;
		}
		this.writeCompletionField();
	}

	writeCompletionField() {
		const completionTextObj = this.getCompletionTextObj();

		this.$beginBlockList.forEach(($item) => {
			const entryId = $item.dataset.entryId;
			const $testCompletionField = $item.querySelector('.quiz-choice_completion');

			if (completionTextObj[entryId] !== null) {
				$testCompletionField.textContent = completionTextObj[entryId]['text'];
				$testCompletionField.className = 'quiz-choice_completion ' + '-' + completionTextObj[entryId]['result'];
			}
		});
	}

	getCompletionTextObj() {
		const lang = document.querySelector('html').getAttribute('lang');
		const storageData = JSON.parse(localStorage.getItem(lang + '_quiz_' + this.courseId));
		let completionTextObj = this.config.items.reduce((acc, cur) => {
			acc[cur.entryId] = null;
			return acc;
		}, {});

		if (storageData) {
			const keys = Object.getOwnPropertyNames(storageData);
			if (keys.length) {
				keys.forEach(key => {
					if (completionTextObj.hasOwnProperty(key)) {
						completionTextObj[key] = {};
						completionTextObj[key]['result'] = storageData[key]['result'];
						completionTextObj[key]['text'] = craft.localization.quiz.multiple[storageData[key]['result']];
					}
				});
			}
		}

		return completionTextObj;
	}

	setInfoText() {
		if (this.config.intro) {
			this.$info.textContent = this.config.intro;
		} else {
			DOMHelper.hide(this.$info);
		}
	}

	addListeners() {
		this.$beginBlockList.forEach(($item, i) => {
			const entryId = this.config.items[i].entryId;
			const $button = $item.querySelector('.quiz-page_begin');
			$item.setAttribute('data-entry-id', entryId);
			$button.textContent = this.config.items[i].buttonLabel;
			$button.addEventListener('click', e => {
				e.preventDefault();
				this.initTest(this.config.items[i]);
			});
		});
	}
}